import { render, staticRenderFns } from "./FileCopy.vue?vue&type=template&id=090ac11e&"
import script from "./FileCopy.vue?vue&type=script&lang=js&"
export * from "./FileCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports